import React from 'react'
import App from './components/App'
import WhatsAppButton from './components/WhatsAppButton'
import {WidgetContextProvider} from './context/widgetContext'
import styles from './index.module.css'

export default function WhatsAppChatWidget({
       textReplyTime = 'Typically replies within a day',
       message = <span>What can we do for you?</span>,
       companyName = 'Support',
       phoneNumber,
       whatsappActive,
       bottom
   }) {
    return (
        <div className={styles.root}>
            {whatsappActive && 
                <WidgetContextProvider>
                    <App
                        textReplyTime={textReplyTime}
                        companyName={companyName}
                        phoneNumber={phoneNumber}
                        message={message}
                        bottom={bottom}
                    />
                    <WhatsAppButton
                        bottom={bottom}
                        show={whatsappActive}
                    />
                </WidgetContextProvider>
            }
        </div>
    )
}
